import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { getCurrencies, getSectors, getTimeZone } from "src/store/system/saga";
import { CurrencyDto, SectorDto, TimezoneDto } from "src/store/system/type";
import * as Yup from "yup";
import { createClient } from "src/store/clients/saga";

const ClientCreateForm = ({
  onHide,
  open,
  onSuccessClick,
}: {
  onSuccessClick: (message: string, p: any) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [currencies, setCurrencies] = useState<CurrencyDto[]>([]);
  const [timezones, setTimezones] = useState<TimezoneDto[]>([]);
  const [sectors, setSectors] = useState<SectorDto[]>([]);
  useEffect(() => {
    if (open) {
      dispatch(
        getCurrencies({
          payload: {
            onSuccess: (message, payload) => setCurrencies(payload),
            onError: () => {},
          },
        })
      );
      dispatch(
        getTimeZone({
          payload: {
            onSuccess: (message, payload) => setTimezones(payload),
            onError: () => {},
          },
        })
      );
      dispatch(
        getSectors({
          payload: {
            onSuccess: (m, p) => setSectors(p),
            onError: () => {},
          },
        })
      );
    }
  }, [dispatch, open]);
  return (
    <React.Fragment>
      <FormDrawer
        drawerProps={{
          isOpen: open,
          onHide: onHide,
          title: t("Clients.CreateFormTitle").toString(),
        }}
        onHide={onHide}
        loader
        initialValues={{
          SectorId: "",
          CurrencyId: "",
          SystemTimeZoneId: "",
          ClientName: "",
          CorporateEmail: "",
          AuthorizedPersonName: "",
          AuthorizedPersonSurname: "",
          CorporatePhone: "",
          CorporateRegisteredTaxOffice: "",
          CorporateRegisteredTaxNumber: "",
        }}
        onSubmit={(values) => {
          dispatch(
            createClient({
              payload: {
                onSuccess: (message, payload) => {
                  onHide();
                  onSuccessClick(message, payload);
                },
                onError: (message) => {
                  toast.error(message, {
                    theme: "colored",
                  });
                },
              },
              body: values,
            })
          );
        }}
        validationSchema={Yup.object().shape({
          SectorId: Yup.string().required("Zorunlu"),
          CorporateEmail: Yup.string().required("Zorunlu"),
          ClientName: Yup.string().required("Zorunlu"),
          AuthorizedPersonName: Yup.string().required("Zorunlu"),
          AuthorizedPersonSurname: Yup.string().required("Zorunlu"),
          CurrencyId: Yup.number().required("Zorunlu"),
          CorporatePhone: Yup.string().required("Zorunlu"),
          SystemTimeZoneId: Yup.string().required("Zorunlu"),
          CorporateRegisteredTaxNumber: Yup.string().required("Zorunlu"),
        })}
        inputs={[
          {
            field: "SectorId",
            label: t("Clients.Sector").toString(),
            type: "select",
            lookup: {
              labelKey: "Name",
              valueKey: "Id",
              options: sectors,
            },
          },
          {
            field: "CurrencyId",
            label: t("Clients.Currency").toString(),
            type: "select",
            lookup: {
              labelKey: "Name",
              valueKey: "EnumId",
              options: currencies,
            },
          },
          {
            field: "SystemTimeZoneId",
            label: t("Clients.SystemTimeZone").toString(),
            type: "select",
            lookup: {
              labelKey: "Name",
              valueKey: "Id",
              options: timezones,
            },
          },
          {
            field: "ClientName",
            label: t("Clients.Name").toString(),
          },
          {
            field: "AuthorizedPersonName",
            col: 6,
            label: t("Clients.AuthorizedPersonName").toString(),
          },
          {
            field: "AuthorizedPersonSurname",
            col: 6,
            label: t("Clients.AuthorizedPersonSurname").toString(),
          },
          {
            field: "CorporateEmail",
            col: 6,
            label: t("Clients.CorporateEmail").toString(),
          },
          {
            field: "CorporatePhone",
            col: 6,
            label: t("Clients.CorporatePhone").toString(),
          },

          {
            field: "CorporateRegisteredTaxOffice",
            label: t("Clients.TaxOffice").toString(),
            col: 6,
          },
          {
            field: "CorporateRegisteredTaxNumber",
            col: 6,
            label: t("Clients.TaxNumber").toString(),
          },
        ]}
      />
    </React.Fragment>
  );
};
export default ClientCreateForm;
